// store/actions/MedicineTypes.js
export const CONFIRMED_CREATE_MEDICINE_ACTION = "CONFIRMED_CREATE_MEDICINE_ACTION";
export const CONFIRMED_DELETE_MEDICINE_ACTION = "CONFIRMED_DELETE_MEDICINE_ACTION";
export const CONFIRMED_EDIT_MEDICINE_ACTION = "CONFIRMED_EDIT_MEDICINE_ACTION";
export const CONFIRMED_GET_MEDICINES = "CONFIRMED_GET_MEDICINES";
